/**
 * COOKIEを扱うモジュール
 */

/**
 * SASのCookie情報定義
 */
export interface SasCookieInfo {
  [key: string]: string;
}

/**
 * SASのCookieのキー定義
 */
export enum SasCookieKeys {
  KEY_TOKEN = 'accessToken',
  KEY_REFRESH_TOKEN = 'refreshToken',
  KEY_USER_ID = 'userId',
  KEY_LANGUAGE = 'language',
  KEY_REGION = 'region',
  KEY_BEFORE_PURCHASE = 'beforePurchase',
  KEY_PURCHASE_COMPLETE = 'purchasecomplete',
  KEY_SERVICE_ID = 'serviceId',
  KEY_MODEL_NAME = 'modelName',
  KEY_TYPE = 'type'
}

/** SASのCookieのダミー値定義 */
export const VALUE_DUMMY_REGION = 'dummy';

// secure属性の文字列を作成
const secure = (): string =>
  window.location.hostname === 'localhost' ? '' : ';secure';

// path属性の文字列を作成
const path = (): string =>
  window.location.hostname === 'localhost' ? '' : ';path=/';

// expires属性の文字列を作成
const expires = (expiresDate: number): string => {
  if (expiresDate === 0) return '';
  const expiresMilSec = expiresDate * 24 * 3600 * 1000;
  const now = new Date();
  now.setTime(now.getTime() + expiresMilSec);
  return `;expires=${now.toUTCString()}`;
};

// SameSite属性の文字列を作成
const sameSite = (sameSiteValue: string): string => {
  if (sameSiteValue === '') return '';
  return `;SameSite=${sameSiteValue}`;
};

/**
 * Cookieを保存する
 * @param cookieName CookieのKey名
 * @param value Cookieの値
 * @param expiresDate Cookieの保持期間の日数。未指定の場合はSession。
 * @param sameSiteValue CookieのSameSite属性。未指定の場合は設定しない。
 */
export const saveCookie = (
  cookieName: string,
  value: string,
  expiresDate = 0,
  sameSiteValue = ''
) => {
  const set_value = encodeURIComponent(value);
  document.cookie = `${cookieName}=${set_value}${path()}${secure()}${expires(
    expiresDate
  )}${sameSite(sameSiteValue)}`;
};

export const deleteCookie = (cookieName: string) => {
  if (document.cookie.indexOf(cookieName) > -1) {
    const oldDateForDelete = 'Thu, 01 Jan 1970 00:00:00 GMT';
    document.cookie = `${cookieName}=${path()};expires=${oldDateForDelete};${secure()}`;
  }
};

/**
 * Cookieを読み込む
 */
export const loadCookie = (): SasCookieInfo => {
  const return_value: SasCookieInfo = {};
  // Cookieを'{key}={value}'の配列として取得
  const cookies = document.cookie.split(';');
  // SASのCookie用キー定義をループ
  const values = Object.values(SasCookieKeys);

  for (const value of values) {
    // 配列として取得したCookieの中からキー定義に一致する値を取得
    const tmp_value = cookies.find((cookie) => {
      return cookie.split('=')[0].trim() === value;
    });
    // 取得した値を変換
    let cookie_value = '';
    if (tmp_value) {
      try {
        cookie_value = tmp_value.substring(tmp_value.indexOf('=') + 1);
      } catch {
        // nop
      }
    }
    // 取得した値をレスポンスに格納
    return_value[value] = decodeURIComponent(cookie_value);
  }
  return return_value;
};
